export const APP_CONFIG: {
  apiUrl: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} = (window as any).config
